import spinner from '../utils/rbmc.spinner';
import paymentPage from "./rbmc.payment-page";
import adyenService from './rbmc.payment-adyen-service';

const checkoutSummary = {
    scrollToBottom() {
        $('html, body').animate({
            scrollTop: $('#jump-mark').offset().top - window.innerHeight + 10
        }, 250);
    }, bindHandlers() {
        $('#finalPaymentSubmit').on('click', (evt) => {
            paymentPage.submitPaymentDetails();
            if ('checkout' in RedBull.tracking) {
                dataLayer.push(RedBull.tracking.checkout.UA);
                dataLayer.push(RedBull.tracking.checkout.GA4);
            }
            spinner.spinnerVisibility(true);
        });
    }
};
$(() => {
    if ($('#checkout-summary-page').length) {
        checkoutSummary.scrollToBottom();
        checkoutSummary.bindHandlers();
        adyenService.cacheSelectors();
        adyenService.showPayButton();
    }
});

export default checkoutSummary
